// A API manda o percentual como decimal ("10.0", "7.5"). Na tela vai sem o ".0" e com
// vírgula: "10%", "7,5%". Antes cada componente repetia essa conta, e os que esqueceram
// mostravam "10.0%" e "7.5%".
export const formatCouponPercent = (
  value: number | string | null | undefined
) => `${String(Number(value) || 0).replace('.', ',')}%`
